/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2025) Takeda. All Rights Reserved
 */

import React, { AnchorHTMLAttributes, FC } from 'react';

import { mailPattern } from '../../../domain/validation.constants';

export const VdzAnchor: FC<AnchorHTMLAttributes<HTMLAnchorElement>> = ({
  children,
  className = 'underline text-brand-blue break-words',
  ...props
}) => {
  const { href } = props;

  const needsMailto =
    href && mailPattern.test(href as string) && !href.includes('mailto:');
  const processedHref = needsMailto ? `mailto:${href}` : href;

  return (
    <a
      {...props}
      className={className}
      href={processedHref}
      rel="noreferrer"
      target="_blank"
    >
      {children}
    </a>
  );
};
